import { createFileRoute } from '@tanstack/react-router';
import { SopEditorPage } from '@/features/sops/pages/sop-editor-page';

export const Route = createFileRoute('/_app/sops/new')({ component: SopEditorPage });
